import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../utilities/classNames";

function BlockQuote(props) {
  var attribution = props.attribution,
      avatar = props.avatar,
      cite = props.cite,
      link = props.link,
      small = props.small,
      text = props.text;
  var getClassName = getClassNameFactory(BlockQuote.displayName);
  var withAvatar = avatar ? "withAvatar" : null;
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames({
        small: small,
        withAvatar: withAvatar
      })
    })
  }, avatar && !small && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "avatar"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "avatarBounding"
    })
  }, avatar)), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "body"
    })
  }, /*#__PURE__*/React.createElement("blockquote", {
    cite: cite,
    className: getClassName({
      descendantName: "quote"
    })
  }, text), avatar && small && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "avatar"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "avatarBounding"
    })
  }, avatar)), (attribution || link) && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "footer"
    })
  }, attribution && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "attribution"
    })
  }, attribution), link && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "link"
    })
  }, link))));
}

BlockQuote.displayName = "BlockQuote";
BlockQuote.defaultProps = {
  small: false
};
export default BlockQuote;